import { render } from "./platform_switcher.html?vue&type=template&id=4bf7cb3a&scoped=true&external"
import script from "./platform_switcher.js?vue&type=script&lang=js&external"
export * from "./platform_switcher.js?vue&type=script&lang=js&external"

import "./platform_switcher.css?vue&type=style&index=0&id=4bf7cb3a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf7cb3a"]])

export default __exports__